import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function requestReducer(state = initialState.Request, action) {
    switch (action.type) {
        case types.GET_REQUESTS_SUCCESSFULL: 
        return {
            ...state,AllRequests: action.getResponse
        };
        case types.POST_SUCCESSFULL: return {
            ...state,RequestId: action.postResponse
        };
        case types.GET_PASTREQUESTS_SUCCESSFUL: return{
            ...state,AllPastRequests: action.getResponse
        }
        case types.GET_SELECTED_REQUEST_SUCCESSFULL: 
        return {
            ...state,SelectedRequest: action.getResponse
        };
        case types.GET_ZONE_TIMEZONE_DETAIL: 
        return {
            ...state,Zone_TimeZone: action.getResponse
        };

        default : return state; 
    }   
}